import {AfterViewInit, Directive, ElementRef, inject, OnDestroy} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[rightScrollbarWidth]',
  standalone: true,
})
export class RightScrollbarWidthDirective implements AfterViewInit, OnDestroy {
  readonly #el: ElementRef<HTMLElement> = inject(ElementRef);
  readonly #nativeElement = this.#el.nativeElement;

  #debounceTimeout: ReturnType<typeof setTimeout> | undefined;

  #resizeObserver = new ResizeObserver(
    (entries) => {
      if (entries.length < 1) {
        this.#updateCssVar(0);
      }
      this.#debounceUpdateScrollbarWidth(entries.at(0)?.target as HTMLElement);
      this.#resizeObserver.disconnect();
    },
  );

  #observeElement() {
    const element = this.#nativeElement;
    this.#resizeObserver.observe(element);
    this.#debounceUpdateScrollbarWidth(element);
  }

  #debounceUpdateScrollbarWidth(element: HTMLElement): void {
    clearTimeout(this.#debounceTimeout);
    this.#debounceTimeout = setTimeout(() =>
        this.#updateScrollbarWidth(element),
      20,
    );
  }

  #updateScrollbarWidth(element: HTMLElement): void {
    const {offsetWidth, clientWidth} = element;
    this.#updateCssVar(offsetWidth - clientWidth);
    this.#nativeElement.style.overflow = '';
  }

  #updateCssVar(width: number): void {
    document.documentElement.style.setProperty('--right-scrollbar-width', width + 'px');
  }

  ngAfterViewInit(): void {
    this.#observeElement();
    this.#nativeElement.style.overflow = 'scroll';
  }

  ngOnDestroy(): void {
    this.#resizeObserver.disconnect();
  }
}
